// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import Paging from "./Paging";
import RequestStatus, { processRequestStatus, processRequestStatusArray } from "entity/RequestStatus";
import RequestStatusType from "enums/RequestStatusType";

import { QueryParams, RestController, RestRequest } from "./RestController";

export default class UtilController extends RestController {

    /*
     Check status of a request
     */

    getRequestStatus(requestStatusId: string): Promise<RequestStatus> {
        let request = new RestRequest("/api/v1/util/request/status/" + requestStatusId + "", "GET", null, undefined);
        return this.request(request, processRequestStatus) as Promise<RequestStatus>;
    }

    /*
     Get list of request based on their status
     */

    getRequests(status?: RequestStatusType, page?: Paging): Promise<RequestStatus[]> {
        const queryParams: QueryParams = { };
        if (status !== undefined) {
          queryParams.status = status;
        }
        let request = new RestRequest("/api/v1/util/request/status", "GET", null, queryParams);
        if (page) request.addPaging("", page);

        return this.request(request, processRequestStatusArray) as Promise<RequestStatus[]>;
    }

}
